module.exports = "\n\n<md-card>\n<p>\n  personal-cabinet works!\n</p>\n  <p>\n  {{clientData.activated }}\n  </p>\n  <p>\n  {{clientData.clientId }}\n  </p>\n\n  <button fxFlex=\"45\"\n          class=\"mdl-button mdl-js-button  mdl-js-ripple-effect mdl-button--raised mdl-button--colored next-on-order\"\n          (click)=\"logout()\">\n    Вихід\n  </button>\n</md-card>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/personal-cabinet/personal-cabinet.component.html
// module id = ../../../../../src/app/personal-cabinet/personal-cabinet.component.html
// module chunks = 0